import React, { useState, useEffect } from 'react';
import DataGrid from 'react-data-grid';
//import { ResizeObserver } from '@juggle/resize-observer';
import 'react-data-grid/lib/styles.css';
import { ActionButton, DatePicker, Dropdown, Icon, IconButton, TagPicker, Toggle, TooltipHost } from '@fluentui/react';
import { Col, Row } from 'react-bootstrap';
import { Pagination } from '@uifabric/experiments';
import './style.css'
import PropTypes from 'prop-types';
import moment from 'moment';
import CCurrencyTextBox from '../../../Common/CCurrencyTextBox';
import MatrixToolbar from './MatrixToolbar';
import * as XLSX from 'xlsx';
import { useTranslation } from 'react-i18next';
import {  isNull, groupBy as rowGrouper } from 'lodash-es';
import i18next from 'i18next';
import { isNullOrEmpty, isNullUndefinedOrEmpty, showMessage } from '../../../../common/Helpers';
import { useSelector } from 'react-redux';
import MessageBox from '../../../Common/Message/MessageBox';
import { __MessageTypes } from '../../../../common/Dictionaries';


const Matrix = (props) => {
    const { _contractPropValueIdSelected: contractPropValueIdSelected } = useSelector((state) => state.maintainerScope);
    const { t } = useTranslation();

    const { 
        inputParam_Rows = [],
        inputParam_PageSize = 10,

        inputParam_Configuration = null,
        inputParam_GroupedColumnList = null,
        inputParam_Height = 70,
        inputParam_ExternalExportTemplates = null,
        
        inputParam_SetterParentList = null,

        inputParam_FireUpdateInternalRows = false,
        inputParam_SetFireUpdateInternalRows = null
    } = props;

    let { 
        inputParam_Columns = [],
    } = props;

    const [expandedGroupIds, setExpandedGroupIds] = useState(
        new Set([1, 2])
    );

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const [rows, setRows] = useState(inputParam_Rows);
    const [filteredRows, setFilteredRows] = useState([...rows]);

    const [currentPage, setCurrentPage] = useState(1);
    const startIndex = (currentPage - 1) * inputParam_PageSize;
    const endIndex = startIndex + inputParam_PageSize;
    const [currentPageData, setCurrentPageData] = useState(filteredRows.slice(startIndex, endIndex));

    const [sortColumns, setSortColumns] = useState([{ columnKey: '', direction: '' }]);
    const [filterValues, setFilterValues] = useState({});

    const totalPages =  Math.ceil(currentPageData.length / inputParam_PageSize);
    
    const fileInputRef = React.useRef(null);

    useEffect(() => {
        if (inputParam_FireUpdateInternalRows === true) {
            inputParam_SetFireUpdateInternalRows && inputParam_SetFireUpdateInternalRows(false)
            setRows(inputParam_Rows);
        }
    }, [inputParam_FireUpdateInternalRows]);

    const TextEditor = ({ row, column }) => {
        const [value, setValue] = useState(row[column.key]);
    
        const handleInputChange = (event) => {
            setValue(event.target.value);
        };
    
        const handleKeyDown = (event) => {
            if (event.key === 'Enter') {
                const updatedRows = [...rows];
                const updatedRow = { ...row, [column.key]: value };
                const rowIndex = updatedRows.findIndex((r) => r.id === row.id); 
                updatedRow.isUpdated = true;
                updatedRows[rowIndex] = updatedRow;
                updatedRows[rowIndex]._rowState = null;
                setRows(updatedRows);
                setFilteredRows(updatedRows);


                const updatedRowsPageData = [...currentPageData];
                const updatedRowPageData = { ...row, [column.key]: value };
                const rowIndexPageData = updatedRowsPageData.findIndex((r) => r.id === row.id); 
                updatedRowPageData.isUpdated = true;
                updatedRowsPageData[rowIndexPageData] = updatedRowPageData;
                updatedRowsPageData[rowIndexPageData]._rowState = null;
                setCurrentPageData(updatedRowsPageData);

                inputParam_SetterParentList && inputParam_SetterParentList(updatedRowsPageData);
            }
        };
    
        useEffect(() => {
            setValue(row[column.key]);
        }, [row, column]);
    
        return (
            <input
                type="text"
                value={value}
                onChange={handleInputChange}
                onKeyDown={handleKeyDown}
                className='w-100'
            />
        );
    };
    
    const DropDownEditor = ({ row, column }) => {
        const [selectedOption, setSelectedOption] = useState(row[column.key]);
      
        const handleDropdownChange = (event, option) => {
            const updatedRow = { ...row, [column.key]: option.key };
            const updatedRows = [...rows];
            const rowIndex = updatedRows.findIndex((r) => r.id === row.id);
            updatedRow.isUpdated = true;
            updatedRows[rowIndex] = updatedRow;
            updatedRows[rowIndex]._rowState = null;
            setRows(updatedRows);
            setFilteredRows(updatedRows);

            
            const updatedRowPageData = { ...row, [column.key]: option.key };
            const updatedRowsPageData = [...currentPageData];
            const rowIndexPageData = updatedRowsPageData.findIndex((r) => r.id === row.id); 
            updatedRowPageData.isUpdated = true;
            updatedRowsPageData[rowIndexPageData] = updatedRowPageData;
            updatedRowsPageData[rowIndexPageData]._rowState = null;
            setCurrentPageData(updatedRowsPageData);

            inputParam_SetterParentList && inputParam_SetterParentList(updatedRows);
        };
      
        useEffect(() => {
            setSelectedOption(row[column.key]);
        }, [row, column]);
      
        return (
            <div>
                    <Dropdown
                        selectedKey={selectedOption}
                        options={column.editorOptions}
                        onChange={handleDropdownChange}
                        styles={{ dropdown: { width: '100%' } }}
                    />
            </div>
        );
    };
    
    const YesNoEditor = ({ row, column }) => {
        const handleToggleChange = (ev, checked) => {
            const updatedRow = { ...row, [column.key]: checked ? 'Yes' : 'No' };
            const updatedRows = [...rows];
            const rowIndex = updatedRows.findIndex((r) => r.id === row.id);
            updatedRow.isUpdated = true;
            updatedRows[rowIndex] = updatedRow;
            updatedRows[rowIndex]._rowState = null;
            setRows(updatedRows);
            setFilteredRows(updatedRows);


            const updatedRowPageData = { ...row, [column.key]: checked ? 'Yes' : 'No' };
            const updatedRowsPageData = [...currentPageData];
            const rowIndexPageData = updatedRowsPageData.findIndex((r) => r.id === row.id); 
            updatedRowPageData.isUpdated = true;
            updatedRowsPageData[rowIndexPageData] = updatedRowPageData;
            updatedRowsPageData[rowIndexPageData]._rowState = null;
            setCurrentPageData(updatedRowsPageData);

            inputParam_SetterParentList && inputParam_SetterParentList(updatedRows);
        };
      
        return (
            <Toggle
                checked={row[column.key] === 'Yes'}
                onChange={handleToggleChange}
                onText="Yes"
                offText="No"
            />
        );
    };
    
    const DatePickerEditor = ({ row, column }) => {
        const [selectedDate, setSelectedDate] = useState(row[column.key]);
      
        const handleDateChange = (date) => {
            const updatedRow = { ...row, [column.key]: moment(date).format('MM/DD/YYYY') };
            const updatedRows = [...rows];
            const rowIndex = updatedRows.findIndex((r) => r.id === row.id);
            updatedRow.isUpdated = true;
            updatedRows[rowIndex] = updatedRow;
            updatedRows[rowIndex]._rowState = null;
            setRows(updatedRows);
            setFilteredRows(updatedRows);


            const updatedRowPageData = { ...row, [column.key]: moment(date).format('MM/DD/YYYY') };
            const updatedRowsPageData = [...currentPageData];
            const rowIndexPageData = updatedRowsPageData.findIndex((r) => r.id === row.id); 
            updatedRowPageData.isUpdated = true;
            updatedRowsPageData[rowIndexPageData] = updatedRowPageData;
            updatedRowsPageData[rowIndexPageData]._rowState = null;
            setCurrentPageData(updatedRowsPageData);

            inputParam_SetterParentList && inputParam_SetterParentList(updatedRows);
        };
      
        useEffect(() => {
            setSelectedDate(row[column.key]);
        }, [row, column]);
      
        return (
            <div>
                    <DatePicker
                        value={selectedDate !== null ? new Date(selectedDate) : null}
                        onSelectDate={handleDateChange}
                        placeholder="Select a date"
                        styles={{ root: { width: '100%' } }}
                    />
            </div>
        );
    };
    
    const NumberEditor = ({ row, column }) => {
        const handleValueChange = (value) => {
            const updatedRow = { ...row, [column.key]: value };
            const updatedRows = [...rows];
            const rowIndex = updatedRows.findIndex((r) => r.id === row.id);
            updatedRow.isUpdated = true;
            updatedRows[rowIndex] = updatedRow;
            updatedRows[rowIndex]._rowState = null;
            setRows(updatedRows);
            setFilteredRows(updatedRows);


            const updatedRowPageData = { ...row, [column.key]: value };
            const updatedRowsPageData = [...currentPageData];
            const rowIndexPageData = updatedRowsPageData.findIndex((r) => r.id === row.id); 
            updatedRowPageData.isUpdated = true;
            updatedRowsPageData[rowIndexPageData] = updatedRowPageData;
            updatedRowsPageData[rowIndexPageData]._rowState = null;
            setCurrentPageData(updatedRowsPageData);

            inputParam_SetterParentList && inputParam_SetterParentList(updatedRows);
        };
    
        return (
            <CCurrencyTextBox
                labelText={null}
                controlValue={row[column.key]}
                objectPropertyNameForSetter={column.key}
                setterIsPropertyObject={false}
                useControlNameForSetter={false}
                isInvalidControl={ true }
                setterControlValue={handleValueChange}
                disabled={false}
            />
        );
    };
    
    const TagEditor = ({ row, column }) => {
        const handleValueChange = (items) => {
            const selectedValues = items.map((item) => item.key);
    
            const updatedRow = { ...row, [column.key]: selectedValues };
            const updatedRows = [...rows];
            const rowIndex = updatedRows.findIndex((r) => r.id === row.id);
            updatedRow.isUpdated = true;
            updatedRows[rowIndex] = updatedRow;
            updatedRows[rowIndex]._rowState = null;
            setRows(updatedRows);
            setFilteredRows(updatedRows);


            const updatedRowPageData = { ...row, [column.key]: selectedValues };
            const updatedRowsPageData = [...currentPageData];
            const rowIndexPageData = updatedRowsPageData.findIndex((r) => r.id === row.id); 
            updatedRowPageData.isUpdated = true;
            updatedRowsPageData[rowIndexPageData] = updatedRowPageData;
            updatedRowsPageData[rowIndexPageData]._rowState = null;
            setCurrentPageData(updatedRowsPageData);

            inputParam_SetterParentList && inputParam_SetterParentList(updatedRows);
        };
    
        const resolveSkillsSuggestions = (filterText) => {
            const filteredOptions = column.options.filter((option) =>
                option.toLowerCase().includes(filterText.toLowerCase())
            );
            return filteredOptions.map((value) => ({
                key: value,
                name: value,
            }))
        };
    
        const selectedItems = row[column.key].map((value) => ({
            key: value,
            name: value,
        }));
        
        return (
            <TagPicker
                selectedItems={selectedItems}
                onResolveSuggestions={resolveSkillsSuggestions} // Configurar la función de búsqueda personalizada
                onChange={handleValueChange}
                itemLimit={5}
                inputProps={{
                    placeholder: 'Type to add a skill',
                    autoComplete: 'off',
                }}
                options={column.options}
            />
        );
    };

    const ComponentEditor = ({ row, column }) => {
        return column.editorComponent();
    };

    const getEditor = (type) => {
        switch (type) {
            case 'Text':
                return TextEditor
            case 'Bool':
                return YesNoEditor
            case 'Number':
                return NumberEditor
            case 'Tag':
                return TagEditor
            case 'Date':
                return DatePickerEditor
            case 'Select':
                return DropDownEditor
            case 'ComponentPanel':
                return ComponentPanelRenderer
            case 'ComponentCustom':
                return ComponentCustomRenderer
            default:
                return undefined
        }
    };

    const handleUploadData = () => {
        fileInputRef.current.click();
    };

    const handleDownloadData = () => {
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.aoa_to_sheet([inputParam_Columns.filter(x => x.includeInTemplate === true).map(x => x.name), []]);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Template');

        XLSX.writeFile(workbook, 'TemplateData.xlsx');
    };

    const handleExportData = () => {
        const workbook = XLSX.utils.book_new();

        const aux_rows = []

        rows.forEach(row => {
            let aux_row = {};
            inputParam_Columns.forEach(column => {
                if (column.exportable) {
                    if (column.readOnlyRenderCellType == 'isDropdown') {
                        aux_row[column.key] = row[column.key] !== null ? column.editorOptions.find(x => x.key === row[column.key]).text : "";
                    }
                    else {
                        aux_row[column.key] = row[column.key];
                    }
                }
            });

            aux_rows.push(aux_row);
        });

        const worksheet = XLSX.utils.json_to_sheet(aux_rows, { header: inputParam_Columns.filter(x => x.exportable).map(column => column.key) });
        
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');

        XLSX.writeFile(workbook, 'ExportedData.xlsx');
    };

    const handleSaveAllNewData = async () => {
        let result = null;
        if (!isNullUndefinedOrEmpty(inputParam_Configuration.handlers.handlerSaveAll)) {
            result = await inputParam_Configuration.handlers.handlerSaveAll(rows, setRows, setFilteredRows);
        }
    };

    const handleAddRow = () => {
        let defaultObject = {};
        const lowerId = inputParam_Rows.length === 0 ? 1 : inputParam_Rows.reduce((min, obj) => obj.id < min ? obj.id : min, inputParam_Rows[0].id);
        let columnDefaultValue = null;

        inputParam_Columns.forEach((column) => {

            switch (column._type) {
                case 'string':
                    columnDefaultValue = ''
                break;
                case 'number':
                    columnDefaultValue = 0
                break;
                case 'boolean':
                    columnDefaultValue = false
                break;
                case 'tag':
                    columnDefaultValue = []
                break;
                case 'date':
                    columnDefaultValue = null
                break;
                case 'dorpdown':
                    columnDefaultValue = ''
                break;
                default:
                    columnDefaultValue = null
            }
            
            defaultObject[column.key] = column.key === "id" ? (lowerId > 0 ? lowerId * -1 : lowerId - 1) : columnDefaultValue;
        });

        defaultObject._rowState = null;
        
        delete defaultObject.actions;


        rows.unshift(defaultObject);

        setRows(rows)
        setFilteredRows(rows)

        const _startIndex = (currentPage - 1) * inputParam_PageSize;
        const _endIndex = _startIndex + inputParam_PageSize;
        setCurrentPageData(rows.slice(_startIndex, _endIndex))
        inputParam_SetterParentList && inputParam_SetterParentList(rows);
    };

    const handleRowSave = async (rowId) => {
        const updatedRows = [...rows];
        const rowsFilred = [...currentPageData];
        const updatedRow = updatedRows.find(x => x.id === rowId)
        let isValidRow = true;
        
        for (let index = 0; index < inputParam_Columns.length; index++) {
            const column = inputParam_Columns[index];
            if (column.required && isNullOrEmpty(updatedRow[column.key])) {
                isValidRow = false;
                break;
            }
        }

        if (isValidRow) {
            let result = {id: 0, flag: true};

            if (!isNullUndefinedOrEmpty(inputParam_Configuration.handlers.handlerSave)) {
                result = await inputParam_Configuration.handlers.handlerSave(updatedRow.id, updatedRow, inputParam_Configuration.auxiliarListCallbackOnAdd, contractPropValueIdSelected);
            }

            if (result.item !== undefined && result.item !== null) {
                const updatedRowFiltred = rowsFilred.find(x => x.id === updatedRow.id);
        
                inputParam_Columns.forEach(column => {
                    if (column.editable === false) {
                        updatedRow[column.key] = result.item[column.key];
                        updatedRowFiltred[column.key] = result.item[column.key];
                    }
                });

                if (result.flag) {
                    updatedRow.id = result.id;
                    updatedRow._rowState = true;
        
                    updatedRowFiltred.id = result.id;
                    updatedRowFiltred._rowState = true;
                }
                else {
                    updatedRow._rowState = false;
                    updatedRowFiltred._rowState = false;
                }
        
                setRows(updatedRows)
                setFilteredRows(rowsFilred)
                inputParam_SetterParentList && inputParam_SetterParentList(updatedRows);
            }
        }
        else {
            showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-requireddatanotset'))
        }
    };

    const handleRowDelete = async (rowId) => {
        const copyRows = [...rows];
        const removedRow = copyRows.find(x => x.id === rowId)
        let result = {id: 0, flag: true};

        if (!isNullUndefinedOrEmpty(inputParam_Configuration.handlers.handlerDelete)) {
            if (rowId > 0) {
                result = await inputParam_Configuration.handlers.handlerDelete(removedRow.id, inputParam_Configuration.auxiliarListCallbackOnAdd);
            }
        }

        if (result.flag) {
            const newRows = copyRows.filter(x => x.id !== rowId)
            setRows(newRows);
            setFilteredRows(newRows)
    
            const _startIndex = (currentPage - 1) * inputParam_PageSize;
            const _endIndex = _startIndex + inputParam_PageSize;
            setCurrentPageData(newRows.slice(_startIndex, _endIndex))
            inputParam_SetterParentList && inputParam_SetterParentList(newRows);
        }
    };

    const handleRowCancel = async (rowId) => {
        const copyRows = [...rows];
        const canceledRow = copyRows.find(x => x.id === rowId)
        let result = {id: 0, flag: true};

        if (!isNullUndefinedOrEmpty(inputParam_Configuration.handlers.handlerCancel)) {
            if (rowId > 0) {
                result = await inputParam_Configuration.handlers.handlerCancel(canceledRow.id, inputParam_Configuration.auxiliarListCallbackOnAdd);
            }
        }

        if (result.flag) {
            
            copyRows.forEach(row => {
                if (row.id === result.item.id) {
                    row = result.item;
                }
            });
            copyRows.forEach(row => {
                if (row.id === result.item.id) {
                    for (const property in result.item) {
                        row[property] = result.item[property]
                    }
                }
            });
            
            setRows(copyRows);
            setFilteredRows(copyRows)
    
            const _startIndex = (currentPage - 1) * inputParam_PageSize;
            const _endIndex = _startIndex + inputParam_PageSize;
            setCurrentPageData(copyRows.slice(_startIndex, _endIndex))
            inputParam_SetterParentList && inputParam_SetterParentList(copyRows);
        }
    };

    const handleGridRowsUpdated = ({ fromRow, toRow, updated }) => {
      setRows((prevRows) => {
        const updatedRows = [...prevRows];
  
        for (let i = fromRow; i <= toRow; i++) {
          updatedRows[i] = { ...updatedRows[i], ...updated };
        }
  
        inputParam_SetterParentList && inputParam_SetterParentList(updatedRows);

        return updatedRows;
      });
    };

    const isValidDate = (fechaString) => {
        const fecha = moment(fechaString, 'YYYY-MM-DDTHH:mm:ss', true);
        return fecha.isValid() && fecha.format('YYYY-MM-DDTHH:mm:ss') === fechaString;
    };
      
    const handleFilterChange = (columnKey, value) => {
        const column = inputParam_Columns.find(x => x.key === columnKey);
        let updatedRows = []

        if (column.readOnlyRenderCellType == 'isDropdown' === true) {
            const options = column.editorOptions.filter(x => x.text.toString().toLowerCase().includes(value.toLowerCase()))
            updatedRows = rows.filter((row) => {
                const cellValue = row[columnKey];
                
                return (options.filter(x => x.key === cellValue).length > 0);
            });
        }
        else {
            updatedRows = rows.filter((row) => {
                const cellValue = !isValidDate(row[columnKey]) ? row[columnKey] : moment(row[columnKey]).format('DD/MM/YYYY');
                return !isNull(cellValue) ? cellValue.toString().toLowerCase().includes(value.toLowerCase()) : false;
            });
        }

        setFilteredRows(updatedRows);

        const _startIndex = (currentPage - 1) * inputParam_PageSize;
        const _endIndex = _startIndex + inputParam_PageSize;
        setCurrentPageData(updatedRows.slice(_startIndex, _endIndex))

        setFilterValues((prevFilterValues) => ({
            ...prevFilterValues,
            [columnKey]: value,
        }));

        setCurrentPage(1)
    };

    const handleSort = (column) => {
        const columnKey  = column.key;
        const { direction } = sortColumns[0];
        let newDirection = 'ASC';
    
        if (columnKey === sortColumns[0].columnKey) {
            newDirection = direction === 'ASC' ? 'DESC' : 'ASC';
        }
    
        setSortColumns([{ columnKey, direction: newDirection }]);
    
        const sortedRows = [...filteredRows];
    
        sortedRows.sort((a, b) => {
            const valueA = a[columnKey];
            const valueB = b[columnKey];
    
            if (valueA < valueB) {
                return newDirection === 'ASC' ? -1 : 1;
            }
            if (valueA > valueB) {
                return newDirection === 'ASC' ? 1 : -1;
            }
    
            return 0;
        });
        setCurrentPage(1);
        setFilteredRows(sortedRows);

        const _startIndex = (currentPage - 1) * inputParam_PageSize;
        const _endIndex = _startIndex + inputParam_PageSize;
        setCurrentPageData(sortedRows.slice(_startIndex, _endIndex))
    };
  
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber + 1);

        const _startIndex = (pageNumber) * inputParam_PageSize;
        const _endIndex = _startIndex + inputParam_PageSize;
        setCurrentPageData(rows.slice(_startIndex, _endIndex))
    };

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();

        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            let lowerId = inputParam_Rows.length === 0 ? 1 : inputParam_Rows.reduce((min, obj) => obj.id < min ? obj.id : min, inputParam_Rows[0].id);

            const convertedData = jsonData.slice(1).map((row, rowIndex) => {
                const convertedRow = {};
                row.forEach((cell, columnIndex) => {
                    const columnName = inputParam_Columns.find(x => x.index === columnIndex).key;
                    convertedRow[columnName] = cell;
                });

                convertedRow.id = (lowerId + 1) * -1;

                lowerId++;

                return convertedRow;
            });

            let newArrayDifferentProperties = [...convertedData, ...rows];

            let newArray = newArrayDifferentProperties.map(item => {
                inputParam_Columns.forEach(column => {
                    if (!item.hasOwnProperty(column.key)) {
                        item[column.key] = '';

                        return item;
                    }
                });

                return item;
            });

            setRows(newArray);
            setFilteredRows(newArray)

            const _startIndex = (currentPage - 1) * inputParam_PageSize;
            const _endIndex = _startIndex + inputParam_PageSize;
            setCurrentPageData(newArray.slice(_startIndex, _endIndex))
            inputParam_SetterParentList && inputParam_SetterParentList(newArray);
        };

        reader.readAsArrayBuffer(file);
        fileInputRef.current.value = '';
    };

    const renderHeaderWithIcon = ({ column }) => {
        let directionIconType = sortColumns[0].columnKey.toLowerCase() === column.key.toLowerCase() ?
            sortColumns[0].direction === 'ASC' ? 'SortDown' : 'SortUp' : 'Sort';
        const columnKey = column.key;
        const filterValue = filterValues[columnKey] || '';

        return (
            <Row className="h-100 lh-initial px-2">
                <Col className='px-2 m-0'>
                    <Row className='h-50 p-0 m-0'>
                        <Col className="p-0 m-0 my-auto">
                            <div>{column.name}</div>
                        </Col> 
                        <Col className="col-auto me-auto p-0 m-0 my-auto">
                            <Icon
                                className="cursor-pointer text-end"
                                iconName={ directionIconType }
                                onClick={() => handleSort(column)}
                            />
                        </Col> 
                    </Row>
                    <Row className='h-50 p-0 m-0'>
                        <Col className='p-0 m-0'>
                            <input
                                type="text"
                                value={filterValue}
                                onChange={(e) => handleFilterChange(columnKey, e.target.value)}
                                className="w-100 header-filter-text"
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>
        );
    };

    const getCellStyles = (row, column, value) => {

        let color = "transparent";
        let title = undefined;

        if (column.required) {
            if (isNullOrEmpty(value)) {
                title = t('data-lang-lbl-required')
                color = "#FF3A4B";
            }
            else {
                if (row._rowState !== undefined) {
                    if (row._rowState !== null) {
                        if (row._rowState === false) {
                            title = t('data-lang-lbl-required')
                            color = "#FF3A4B";
                        }
                        else {
                            title = t('data-lang-lbl-saved')
                            color = "#7fd7a7";
                        }
                    }
                    else {
                        title = t('data-lang-lbl-pendingsave')
                        color = "#000000";
                    }
                } else {
                    title = t('data-lang-lbl-doubleclickandmodify')
                    color = "transparent";
                }
            }
        }
        else {
            title = t('data-lang-msg-doubleclickandmodify')
            color = "transparent";
        }

        return {
            style: {
                borderWidth: "1px",
                borderStyle: "solid",
                borderColor: color
            },
            title: title
        }
    };

    const TagCellRenderer = ({ row, column }) => {
        const customStyle = getCellStyles(row, column, row[column.key].map(item => item).join("; "));

        return (
            <div title={customStyle.title} style={((inputParam_Configuration.disableCellStyles !== undefined ? inputParam_Configuration.disableCellStyles : false) !== undefined ? (inputParam_Configuration.disableCellStyles !== undefined ? inputParam_Configuration.disableCellStyles : false) : false) ? undefined : customStyle.style}>
                <div className='px-2'>
                {
                    row[column.key].map(item => item).join("; ")
                }
                </div>
            </div>
        );
    };

    const DateCellRender = ({ row, column }) => {
        const customStyle = getCellStyles(row, column, moment(row[column.key]).format(column.dateFormat));

        return (
            <div title={customStyle.title} className='h-100' style={(inputParam_Configuration.disableCellStyles !== undefined ? inputParam_Configuration.disableCellStyles : false) ? undefined : customStyle.style}>
                <div className='px-2'>
                {
                    row[column.key] !== null ? moment(row[column.key]).format(column.dateFormat) : ""
                }
                </div>
            </div>
        );
    };

    const DropDownCellRenderer = ({ row, column }) => {
        const fieldValue = column.editorOptions.find(x => x.key === row[column.key]);
        const customStyle = getCellStyles(row, column, fieldValue ? fieldValue.text : '');
        
        return (
            <div title={customStyle.title} className='h-100' style={(inputParam_Configuration.disableCellStyles !== undefined ? inputParam_Configuration.disableCellStyles : false) ? undefined : customStyle.style}>
                <div className='px-2'>
                {
                    fieldValue && fieldValue.text
                }
                {
                    !fieldValue && t('data-lang-msg-nocoincidenses')
                }
                </div>
            </div>
        );
    };

    const YesNoCellRenderer = ({ row, column }) => {
        const fieldValue = row[column.key] === 1 || row[column.key] === 'Yes' ||  row[column.key] === 'Sí' || row[column.key] === 'True' || row[column.key] === 'true' || row[column.key] === true ? t('data-lang-lbl-yes') : t('data-lang-lbl-no');
        const customStyle = getCellStyles(row, column, fieldValue);
        
        return (
            <div title={customStyle.title} style={(inputParam_Configuration.disableCellStyles !== undefined ? inputParam_Configuration.disableCellStyles : false) ? undefined : customStyle.style}>
                <div className='px-2'>{fieldValue}</div>
            </div>
        );
    };

    const NumerMoneyRenderer = ({ row, column }) => {
        const numberStrValue = !isNullUndefinedOrEmpty(row[column.key]) && !isNaN(row[column.key]) ? row[column.key].toLocaleString(i18next.language, {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }) : row[column.key];
        const customStyle = getCellStyles(row, column, numberStrValue);
        
        return (
            <div title={customStyle.title} className='text-end w-100 h-100' style={(inputParam_Configuration.disableCellStyles !== undefined ? inputParam_Configuration.disableCellStyles : false) ? undefined : customStyle.style}>
                <div className='px-2'>{numberStrValue}</div>
            </div>
        );
    };

    const NumerRenderer = ({ row, column }) => {
        const numberStrValue = !isNullUndefinedOrEmpty(row[column.key]) && !isNaN(row[column.key]) ? row[column.key].toLocaleString(i18next.language, {style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0 }) : row[column.key];
        const customStyle = getCellStyles(row, column, numberStrValue);
        
        return (
            <div title={customStyle.title} className='text-end w-100 h-100' style={(inputParam_Configuration.disableCellStyles !== undefined ? inputParam_Configuration.disableCellStyles : false) ? undefined : customStyle.style}>
                <div className='px-2'>{numberStrValue}</div>
            </div>
        );
    };

    const TextRenderer = ({ row, column }) => {
        const customStyle = getCellStyles(row, column, row[column.key]);

        return ( column.useTooltip ?
            <div title={customStyle.title} className='w-100 h-100' style={(inputParam_Configuration.disableCellStyles !== undefined ? inputParam_Configuration.disableCellStyles : false) ? undefined : customStyle.style}>
                <TooltipHost content={ row[column.key] } calloutProps={{ gapSpace: 0 }} styles={{ root: { display: 'inline-block' } }} >
                    <div className='px-2'>{row[column.key]}</div>
                </TooltipHost>
            </div> :
            <div title={customStyle.title} className='w-100 h-100' style={(inputParam_Configuration.disableCellStyles !== undefined ? inputParam_Configuration.disableCellStyles : false) ? undefined : customStyle.style}>
                <div className='px-2'>{row[column.key]}</div>
            </div>
        );
    };

    const ComponentPanelRenderer = ({ row, column }) => {
        const customStyle = getCellStyles(row, column, row[column.key]);

        return ( column.useTooltip ?
            <div title={customStyle.title} className='w-100 h-100' style={(inputParam_Configuration.disableCellStyles !== undefined ? inputParam_Configuration.disableCellStyles : false) ? undefined : customStyle.style}>
                <TooltipHost content={ row[column.key] } calloutProps={{ gapSpace: 0 }} styles={{ root: { display: 'inline-block' } }} >
                    <div className='px-2'>{row[column.key]}</div>
                </TooltipHost>
                <IconButton iconProps={{iconName: "View"}} onClick={() => column.handlerOpenViewComponent(row)} />
                <IconButton iconProps={{iconName: "Edit"}} onClick={() => column.handlerOpenEditComponent(row, setRows, setFilteredRows, setCurrentPageData)} />
            </div> :
            <div title={customStyle.title} className='w-100 h-100' style={(inputParam_Configuration.disableCellStyles !== undefined ? inputParam_Configuration.disableCellStyles : false) ? undefined : customStyle.style}>
                <div className='d-flex'>
                    <div className='px-2'>{row[column.key]}</div>
                    <IconButton iconProps={{iconName: "View"}} onClick={() => column.handlerOpenViewComponent(row)} />
                    <IconButton iconProps={{iconName: "Edit"}} onClick={() => column.handlerOpenEditComponent(row, setRows, setFilteredRows, setCurrentPageData)} />
                </div>
            </div>
        );
    };

    const ComponentCustomRenderer = ({ row, column }) => {
        const customStyle = getCellStyles(row, column, row[column.key]);

        return  <div className='w-100 h-100'>
                    {column.render(row)}
                </div>
    };

    const DataLangRenderer = ({ row, column }) => {
        const customStyle = getCellStyles(row, column, row[column.key]);
        return  <div className='w-100 h-100' style={(inputParam_Configuration.disableCellStyles !== undefined ? inputParam_Configuration.disableCellStyles : false) ? undefined : customStyle.style}>
                    <div className='px-2'>{t(row[column.key])}</div>   
                </div>
    };

    const ReadOnlyRenderCell = (item) => {
        switch (item.readOnlyRenderCellType) {
            case 'isDropdown':
                return DropDownCellRenderer;
            case 'isYesNo':
                return YesNoCellRenderer;
            case 'isDate':
                return DateCellRender;
            case 'isNumberMoney':
                return NumerMoneyRenderer;
            case 'isNumber':
                return NumerRenderer;
            case 'isTag':
                return TagCellRenderer;
            case 'isComponentPanel':
                return ComponentPanelRenderer;
            case 'isComponentCustom':
                return ComponentCustomRenderer;
            case 'isDataLang':
                return DataLangRenderer;
            default:
                return TextRenderer;
        }
    };

    inputParam_Columns = inputParam_Columns.map((item) => {
        item.headerRenderer = item.isCustomHeader ? renderHeaderWithIcon : undefined;
        item.formatter = ReadOnlyRenderCell(item);
        item.editor = getEditor(item.editorType);
        item.index = item.index;

        return item;
    });

    inputParam_Columns.unshift({
        index: -1,
        key: 'id',
        name: 'Actions',
        editable: false,
        sortable: false,
        filterable: false,
        exportable: false,
        includeInTemplate: false,
        formatter: ({ row }) => (
            <Row className='text-center'>
                <Col className='pe-4 p-0 m-0 text-center d-flex'>
                    {
                        inputParam_Configuration.handlers.handlerSave &&
                        <ActionButton
                            className='ps-3 pe-0'
                            iconProps={{ iconName: 'Save' }}
                            onClick={() => handleRowSave(row.id)}
                            allowDisabledFocus
                            title={t('data-lang-btn-save')}
                            style={{ height: `${inputParam_Height}px` }}
                        />
                    }
                    {
                        row._rowState === null ?
                        <ActionButton
                            className='ps-0 pe-0'
                            iconProps={{ iconName: row.id !== -1 ? 'Cancel' : 'OutlookLogoFill' }}
                            onClick={() => handleRowCancel(row.id)}
                            allowDisabledFocus
                            disabled={row.id !== -1 ? false : true}
                            title={t('data-lang-btn-cancel')}
                            style={{ height: `${inputParam_Height}px` }}
                        /> :
                        <ActionButton
                            className='ps-0 pe-0'
                            iconProps={{ iconName: 'OutlookLogoFill' }}
                            onClick={null}
                            allowDisabledFocus
                            disabled={true}
                            style={{ height: `${inputParam_Height}px` }}
                        />
                    }
                    {
                        inputParam_Configuration.handlers.handlerDelete &&
                        <ActionButton
                            className='ps-0 pe-3'
                            iconProps={{ iconName: 'Delete' }}
                            onClick={() => handleRowDelete(row.id)}
                            allowDisabledFocus
                            title={t('data-lang-btn-delete')}
                            style={{ height: `${inputParam_Height}px` }}
                        />
                    }
                </Col>
            </Row>
        ),
        frozen: true,
        width: 50,
    });
    
    inputParam_Columns = inputParam_Columns.filter(x => inputParam_Configuration.buttons.showRowButtons ? true : x.key !== "id")

    return (
      <div className="react-grid-Container h-95 overflow-hidden pb-6">
            <div className='d-none'>
                <input ref={fileInputRef} type="file" accept=".xlsx" onChange={handleFileUpload} />
            </div>
            <MatrixToolbar
                inputParam_HandleSaveData={handleSaveAllNewData}
                inputParam_HandleUploadData={handleUploadData}
                inputParam_HandleDownloadData={handleDownloadData}
                inputParam_HandleExportData={handleExportData}
                inputParam_HandleAddRow={handleAddRow}
                inputParam_Configuration={inputParam_Configuration}
                inputParam_ExternalExportTemplates={inputParam_ExternalExportTemplates}
                inputParam_CustomOpenPanel={inputParam_Configuration.handlers.handlerOpenPanel}
            />
            <MessageBox
                inputParam_Message={ messageConfig.message }
                inputParam_Display={ messageConfig.showMessage }
                inputParam_MessageType={ messageConfig.messageType }
                inputParam_SetterMessage={ setMessageConfig }
            />
            {
                inputParam_Configuration.showPagination &&
                <div className="text-center">
                    <Pagination
                        selectedPageIndex={ currentPage - 1 }
                        pageCount={ totalPages }
                        itemsPerPage={ inputParam_PageSize }
                        totalItemCount={ currentPageData.length }
                        onPageChange={handlePageChange}
                        firstPageIconProps={{ iconName: 'DoubleChevronLeft' }}
                        previousPageIconProps={{ iconName: 'ChevronLeft' }}
                        nextPageIconProps={{ iconName: 'ChevronRight' }}
                        lastPageIconProps={{ iconName: 'DoubleChevronRight' }}
                        styles={{comboBox:{ marginTop: "-7px" }}}
                    />
                </div>
            }
            <DataGrid
                columns={inputParam_Columns}
                rows={currentPageData}
                onRowsUpdate={handleGridRowsUpdated}
                enableCellSelect={true}
                sortable={true}
                sortColumns={sortColumns}
                onFilter={handleFilterChange}
                headerRowHeight={inputParam_Columns.filter(x => x.isCustomHeader === true).length > 0 ? inputParam_Height * 2.5 : inputParam_Height}
                rowHeight={inputParam_Height}
                groupBy={inputParam_GroupedColumnList}
                rowGrouper={rowGrouper}
                expandedGroupIds={expandedGroupIds}
                onExpandedGroupIdsChange={setExpandedGroupIds}
                className='h-100'
            />
            {
                inputParam_Configuration.showPagination &&
                <div className="text-center">
                    <Pagination
                        selectedPageIndex={ currentPage - 1 }
                        pageCount={ totalPages }
                        itemsPerPage={ inputParam_PageSize }
                        totalItemCount={ currentPageData.length }
                        onPageChange={handlePageChange}
                        firstPageIconProps={{ iconName: 'DoubleChevronLeft' }}
                        previousPageIconProps={{ iconName: 'ChevronLeft' }}
                        nextPageIconProps={{ iconName: 'ChevronRight' }}
                        lastPageIconProps={{ iconName: 'DoubleChevronRight' }}
                        styles={{comboBox:{ marginTop: "-7px" }}}
                    />
                </div>
            }
      </div>
    );
};

Matrix.propTypes = {
    inputParam_Columns: PropTypes.array.isRequired,
    inputParam_Rows: PropTypes.array.isRequired,
    inputParam_PageSize: PropTypes.number.isRequired,
    inputParam_GroupedColumnList: PropTypes.array,
    inputParam_Height: PropTypes.number
};

export default Matrix;